import React from 'react';
import {Checkbox} from 'material-ui';
import FormControlLabel from 'material-ui/Form/FormControlLabel';

export default (props) => {
	return (
		<div>
			<FormControlLabel
				control={
					<Checkbox
					color="primary"
					{...props}
					/>
				}
				label={props.label}
				/>
		</div>
)};


// WEBPACK FOOTER //
// ./src/components/Checkbox.js